import Ajax from "Utils/ajax";
export const getHelpContentList = (data) => Ajax.post('hr/getHelpContentList',data);